import { Container } from '@mui/material';
import Page from '../components/Page';

export default function DashboardApp() {
  return (
    <Page title="Dashboard | Minimal-UI">
      <Container maxWidth="xl">dashboard content</Container>
    </Page>
  );
}
